import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from '@phosphor-icons/react';

const TOOL_LABELS: Record<string, string> = {
  search_alumni: 'Searching alumni…',
  get_alumni_detail: 'Loading profile…',
  summarize_alumni: 'Summarising alumni…',
  find_similar_alumni: 'Finding similar alumni…',
  get_top_donors: 'Fetching top donors…',
  donor_history: 'Loading donation history…',
  donation_analytics: 'Running analytics…',
  recommend_donors: 'Recommending donors…',
  compare_donors: 'Comparing donors…',
  search_projects: 'Searching projects…',
  get_project_detail: 'Loading project…',
  search_proposals: 'Searching proposals…',
  explain_vals: 'Analysing VALS profile…',
};

interface ToolStatusBadgeProps {
  tool: string | null | undefined;
  done?: boolean;
}

export function ToolStatusBadge({ tool, done = false }: ToolStatusBadgeProps) {
  if (!tool) return null;
  const label = TOOL_LABELS[tool] ?? `Running ${tool}…`;

  return (
    <AnimatePresence mode="wait">
      {!done ? (
        <motion.div
          key="running"
          initial={{ opacity: 0, height: 0, scale: 0.95 }}
          animate={{ opacity: 1, height: 'auto', scale: 1 }}
          exit={{ opacity: 0, height: 0, scale: 0.9 }}
          transition={{ type: 'spring', stiffness: 400, damping: 25 }}
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-[12px] bg-orange-50/50 border border-orange-100/50 text-slate-700 text-[13px] font-medium mb-3 shadow-[0_2px_10px_rgba(249,115,22,0.06)] overflow-hidden"
        >
          <div className="w-3.5 h-3.5 rounded-full border-2 border-orange-200 border-t-orange-500 animate-spin" />
          {label}
        </motion.div>
      ) : (
        <motion.div
          key="done"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-[10px] text-slate-400 text-[11px] font-medium mb-3 transition-colors hover:bg-slate-50 border border-transparent hover:border-slate-100 cursor-default"
        >
          <CheckCircle size={14} weight="fill" className="text-emerald-400" />
          {label.replace('…', '')}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
